module.exports = __webpack_public_path__ + "img/153-Kensington Grey.jpg";